import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
// Data
import underwritingService from "data/underwriting"
import { parseDate } from "data/lib/dates"
// Styles
import { Label_s } from 'styles/app-styles'
import { DateText_s } from 'styles/report-styles'
// Types
import { FolderReportProps, ReportFormParameters } from './reports'

type ReportType = 'folder_weighted_average_lease_term'
const displayName = 'Weighted Average Lease Term'

type WeightedAverageLeaseTermParams = ReportFormParameters & {
  as_of_date: string // MM/DD/YYYY
  report: ReportType
}

export const propertyFilter = (property) => property.type === 'Commercial'

export const WeightedAverageLeaseTerm: FC<FolderReportProps> = (props) => {
  const [startdate, setStartDate] = useState<string>(props.reportbegindate)

  useEffect(() => {
    props.setParameters(getParameters())
  }, [startdate])

  function getParameters(): WeightedAverageLeaseTermParams {
    return {
      as_of_date: underwritingService.toISOdate(startdate),
      report: 'folder_weighted_average_lease_term'
    }
  }

  return (
    <>
      <div>
        <Label_s>Start Date</Label_s>
        <DateText_s
          value={parseDate(startdate).format('MM/DD/YYYY')}
          onChange={setStartDate}
          onBlur={setStartDate}
          persist={setStartDate}
          withoutDays
        />
      </div>
    </>
  )
}

WeightedAverageLeaseTerm.displayName = displayName
